import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { math } from 'polished'
import Container from 'components/atoms/Container'
import { H2, Text } from 'components/atoms/Typography'
import { Grid, Box, Flex } from 'components/atoms/Layout'
import { COLORS } from 'config/constants'
import { space, colors } from 'config/theme'
import { pxToRem } from 'utils/helpers'
import Link from 'components/atoms/Link'
import { ReactComponent as Group } from 'assets/svg/group.svg'
import { ReactComponent as NunuHouse } from 'assets/svg/nunu-house.svg'

const CardWrapper = styled(Flex)`
  box-shadow: 4px 13px 40px rgba(111, 111, 111, 0.18);
  border-radius: ${pxToRem(6)};
  overflow: hidden;
`

const styleIcon = (IconComp) => styled(IconComp)`
  width: 100%;
  height: auto;
  color: ${COLORS.WHITE};
`

const Card = ({ color, iconComp: Icon, children }) => (
  <CardWrapper>
    <Flex
      flex={`0 0 ${pxToRem(100)}`}
      justifyContent="center"
      alignItems="center"
      p={math(`${space.m} + ${space.s}`)}
      backgroundColor={color}
    >
      <Icon />
    </Flex>
    <Box flex="1" p="l">
      {children}
    </Box>
  </CardWrapper>
)

Card.propTypes = {
  color: PropTypes.string.isRequired,
  iconComp: PropTypes.element.isRequired,
  children: PropTypes.node.isRequired,
}

const Heading = (props) => (
  <Text color="heading" fontSize="l" fontWeight="bold" mb="1em" {...props} />
)

Card.Heading = Heading

const Cards = () => {
  return (
    <Container>
      <H2 textAlign="center" mb="xl">
        Be one step closer to owning
      </H2>
      <Grid
        gridGap={{ mobile: 'l', desktop: 'xl' }}
        gridTemplateColumns={{ mobile: '1fr', tablet: '1fr 1fr' }}
      >
        <Card color={COLORS.CATALAN} iconComp={styleIcon(Group)}>
          <Card.Heading>How do we do it?</Card.Heading>
          <Text>
            Our experience and reputation helps you get the best deal for the
            situation you are currently in. <Link href="/faq">Learn more</Link>
          </Text>
        </Card>
        <Card color={colors.brandCta} iconComp={styleIcon(NunuHouse)}>
          <Card.Heading>We are NuNu </Card.Heading>
          <Text>
            With over 10 years of experience and backed by one of industry’s
            giants - Crescent Heights.
          </Text>
        </Card>
      </Grid>
    </Container>
  )
}

export default Cards
